import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Profile } from '../_models/profile';

@Injectable()
export class AuthGuard implements CanActivate {
  profile: Profile;

  constructor(private router: Router) {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.checkLogged() && this.checkPermissions(route.data['modules'])) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page
    this.router.navigate(['/login']);
    return false;
  }

  checkLogged() {
    if (localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    } else {
      return false;
    }
  }

  checkPermissions(requiredModules) {
    let access = true;
    let sw = false;

    for (const module of requiredModules) {
      sw = this.profile.haveAccess(module);
      access = access && sw;
    }

    return access;
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts